import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgTextItalic = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M21.875 6.125A.875.875 0 0 1 21 7h-3.744L12.59 21h3.161a.875.875 0 1 1 0 1.75H7A.875.875 0 0 1 7 21h3.744L15.41 7h-3.16a.875.875 0 1 1 0-1.75H21a.875.875 0 0 1 .875.875Z" />
  </svg>
);
export default SvgTextItalic;
